import React from 'react';
import { observer } from 'mobx-react-lite';
import { Window, WindowHeader } from '../overlays';
import { Button } from '../input';
import { ToggleDeceptioAiWindowState } from './toggleDeceptionAiWindowState';

type Props = {
  model: ToggleDeceptioAiWindowState;
  visible?: boolean;
};

export const ToggleDeceptioAiWindow = observer(({ model, visible }: Props) => {
  return (
    <Window
      model={model.window}
      visible={visible}
      isLoading={model.isLoading}
      className="make-team-public-window">
      <WindowHeader model={model.window} title="Toggle Deceptio AI" />

      <hr />

      <div className="window-content">
        <p className="p-bold">
         Are you sure you want to enable/disabled Deception AI for this library?
        </p>
      </div>

      <hr />

      <footer className="window-footer">
        <div className="btn-group right">
          <Button
            className="primary btn-outline medium"
            label="Cancel"
            onClick={() => model.close()}
          />
          <Button
            className="red medium"
            label="Confirm"
            onClick={() => model.submit()}
          />
        </div>
      </footer>
    </Window>
  );
});
